import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImageNodeView from './ImageNodeView';

/**
 * Image extension with a persisted `width` so authors can resize prompt images.
 * Width is stored as an inline style (e.g. `width: 320px`) so the read-only viewer
 * renders the chosen size; `max-width: 100%` in CSS keeps it responsive.
 */
export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => el.style.width || el.getAttribute('width') || null,
        renderHTML: (attrs) => {
          if (!attrs.width) return {};
          const w = typeof attrs.width === 'number' ? `${attrs.width}px` : attrs.width;
          return { style: `width: ${w}` };
        },
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});
